<template>
  <div class="list-item">
    <div class="lmbl">
      <div
        v-for="(item, index) in curList"
        :key="index"
        class="item"
        @click="jumpDetail(item)"
      >
        <img :src="item.headImg" :alt="item.name" />
        <div class="description">
          {{ item.name }}
        </div>
      </div>
    </div>
  
  </div>
</template>
  
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      curList: [],
    };
  },
  // 监听数组变化
  watch: {
    data: {
      immediate: true,
      handler(newVal) {
        this.curList = newVal;
      },
    },
  },
  methods: {
    jumpMore(){
      this.$router.push({
        path: "/lmList",
      });
    },
    // 跳转详情页
    jumpDetail(item) {
      this.$router.push({
        path: "/lamorDetail",
        query: {
          id: item.id,
        },
      });
    },
    formatDate(date) {
      const year = date.slice(0, 4);
      const month = date.slice(4, 6);
      const day = date.slice(6, 8);
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
  
<style lang="scss" scoped>
.list-item {
  width: 95%;
  margin: 15px auto;
  height: fit-content;
  display: flex;
  flex-direction: column;
  .lmbl {
    width: 100%;
    padding: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item {
      position: relative;
      width: 48%;
      height: 166px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      margin-right: 10px;
      margin-bottom: 15px;
      &:nth-child(3) {
        margin-right: 0;
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 0px;
      }
      .description {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.4);
        color: #fff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .more {
    font-weight: 500;
    font-size: 24px;
    color: #000000;
    line-height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 28px;
      height: 15px;
      margin-left: 15px;
    }
  }
}
</style>
  